import cx from 'classnames';
import PT from 'prop-types';
import styles from './styles.scss';

export const Pill = ({ color, children }) => (
  <span className={cx(styles.pill, styles[color])}>{children}</span>
);

Pill.propTypes = {
  children: PT.node.isRequired,
  color: PT.oneOf(['yellow', 'green', 'red', 'blue']),
};
